import React, { useState } from "react";
import "./About.css";
import Fade from "react-reveal/Fade";
import profileImage from "../../assets/images/profile.jpg";

const About = () => {
  const [showMore, setShowMore] = useState(false);

  const shortText = "I'm Himanshu Kumar, a versatile Full Stack Developer specializing in both web and mobile application development. As an Information Technology student at Heritage Institute of Technology, Kolkata, I combine technical expertise with creative problem-solving to build innovative digital solutions.";

  const fullText = `I'm Himanshu Kumar, a versatile Full Stack Developer specializing in both web and mobile application development. As an Information Technology student at Heritage Institute of Technology, Kolkata, I combine technical expertise with creative problem-solving to build innovative digital solutions.

💻 My technical toolkit spans the MERN stack (MongoDB, Express.js, React, Node.js) for web development and React Native with Expo for cross-platform mobile applications. I've developed a diverse portfolio of projects including educational gaming platforms, agricultural support applications, and e-commerce solutions.

🚀 At Jabsz Gaming Studios LLP, I've honed my skills in mobile development, working with technologies like Firebase, Google Authentication, and AdMob integration. My experience includes building responsive interfaces, implementing secure authentication systems, and creating monetization strategies.

🌱 I'm passionate about creating technology that makes a real difference in people's lives. Whether it's helping farmers with digital tools or making education more engaging through interactive games, I strive to develop applications that solve meaningful problems.

🔍 I approach each project with meticulous attention to detail, a commitment to clean code, and a focus on creating intuitive user experiences. I'm constantly expanding my skillset, currently exploring TypeScript, cloud services, and advanced state management techniques.

🤝 I thrive in collaborative environments and enjoy working with cross-functional teams to bring ideas to life. I'm always open to new challenges and opportunities to create impactful digital experiences.`;

  return (
    <div className="about" id="about">
      <div className="about-container">
        <div className="about-content-wrapper">
          <div className="about-img-column">
            <Fade left>
              <div className="about-image-container">
                <img
                  src={profileImage}
                  alt="about_profile"
                  className="about-profile-img"
                />
                <div className="about-image-border-glow"></div>
              </div>
            </Fade>
          </div>

          <div className="about-text-column">
            <Fade right>
              <div className="about-header">
                <h5 className="section-subtitle">Discovery</h5>
                <h1 className="about-heading">About Me</h1>
              </div>

              <div className="about-description">
                <p>
                  {showMore ? fullText : shortText}
                </p>
              </div>

              <div className="about-action">
                <button
                  className="btn btn-cv"
                  onClick={() => setShowMore(!showMore)}
                >
                  {showMore ? 'Read Less' : 'Read More'}
                </button>
              </div>
            </Fade>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
